module.exports = __webpack_public_path__ + "static/media/Asset 8@3x.32da9cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 8@3x.png
// module id = 2400
// module chunks = 0